import Navbar from './components/Navbar';
import Page from './pages/Page';

function App() {
  return (
    <div>
      <Navbar />
      <Page />
    </div>
  );
}

export default App;
